<template>
  <header class="site-header">
    <div class="header-inner">
      <!-- Logo -->
      <router-link to="/wordinfo" class="logo">
        <img src="../assets/weblogo.png" alt="搜搜单词" />
      </router-link>

      <!-- 导航菜单 -->
      <el-menu
        mode="horizontal"
        :default-active="activeMenu"
        router
        class="nav-menu"
      >
        <el-menu-item index="/wordinfo">单词本</el-menu-item>
        <el-menu-item index="/bookword">课本单词</el-menu-item>
        <el-menu-item index="/pictureword">看图记词</el-menu-item>
        <el-menu-item index="/videoword">视频频学</el-menu-item>
        <el-menu-item index="/personinfo">个人中心</el-menu-item>
      </el-menu>

      <!-- 搜索 + 登录 -->
      <div class="header-right">
        <el-input
          v-model="keyword"
          placeholder="输入单词"
          size="small"
          class="search-input"
          clearable
          @keyup.enter.native="onSearch"
        />
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">
          搜索
        </el-button>
        <el-button
          v-if="!isLogin"
          size="small"
          type="text"
          icon="el-icon-user"
          class="login-btn"
          @click="$router.push('/login')"
        >
          登录
        </el-button>
        <el-dropdown v-else @command="onUserCommand">
          <span class="user-name">
            <i class="el-icon-user-solid"></i>
            {{ displayName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="person">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    isLogin() {
      return this.$store.getters.isLogin
    },
    displayName() {
      const info = this.$store.state.teacherInfo
      if (info && (info.username || info.name || info.nickname)) {
        return info.username || info.name || info.nickname
      }
      const token = this.$store.state.token
      if (this.isLogin && token) {
        return '老师 ' + token.slice(-6)
      }
      return ''
    }
  },
  methods: {
    onSearch() {
      const word = (this.keyword || '').trim()
      if (!word) {
        this.$message.warning('请输入要查询的单词')
        return
      }
      this.$store.dispatch('setWord', word)
      if (this.$route.path !== '/wordinfo') {
        this.$router.push('/wordinfo')
      }
    },
    onUserCommand(cmd) {
      if (cmd === 'person') {
        this.$router.push('/personinfo')
      } else if (cmd === 'logout') {
        this.$store.dispatch('clearLogin')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-inner {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  height: 64px;
  display: flex;
  align-items: center;
}

.logo img {
  height: 40px;
  display: block;
}

.nav-menu {
  margin-left: 24px;
  border-bottom: none;
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 200px;
}

.login-btn {
  color: #606266;
}

.user-name {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
  white-space: nowrap;
}
</style>
